/** 存放网络配置信息 */

import { EnvType, HostType } from './type'

export let env = EnvType.prod // 使用环境
export let appVersion = '1.0.22.0.0' // 正式环境打包记得修改 vite.config.js 中minify为terser
export let httpHost
export let httpHostJava
export const appId = 'sixunapplicationcenter'
export const appKey = 'sixunapplicationcenter@202402$#$#@'
export const envInfos = {
  prod: {
    platformApi: 'https://api-platform-applet.td365.com.cn/', // 运营平台小程序API站点
    platformApi2: 'https://api-platform.td365.com.cn/', // 运营平台API站点
    epicureApi: 'https://eqadmin.sixun.com.cn/', //餐饮api（正式）
    passportApi: 'https://api-passport.td365.com.cn/',
    passportWebsite: 'https://passport.td365.com.cn/', // 星系passport后台地址（分享注册使用）
    appcenterWebsite: 'https://appcenter.td365.com.cn/'
    // storeAdmin: 'http://teststoreadminv3.sissyun.com.cn/' // 微商城（微商店）
  },
  pre: {
    platformApi: 'https://beta-api-platform-applet.td365.com.cn/', // 运营平台小程序API站点
    platformApi2: 'https://api-platform.td365.com.cn/', // 运营平台API站点
    epicureApi: 'https://eqadmin.sixun.com.cn/', //餐饮api（正式）
    passportApi: 'https://betaapi-passport.td365.com.cn/',
    passportWebsite: 'https://betapassport.td365.com.cn/', // 星系passport后台地址（分享注册使用）
    appcenterWebsite: 'https://betaappcenter.td365.com.cn/'
    // storeAdmin: 'http://teststoreadminv3.sissyun.com.cn/' // 微商城（微商店）
  },
  test: {
    platformApi: 'https://test-api-platform-applet-local.td365.com.cn/', // 运营平台小程序API站点
    platformApi2: 'https://api-platform.td365.com.cn/', // 运营平台API站点
    epicureApi: 'https://admin-epicure.td365.com.cn/', //餐饮api（测试）
    passportApi: 'https://test-api-passport-local.td365.com.cn/',
    passportWebsite: 'https://test-passport3-local.td365.com.cn/', // 星系passport后台地址（分享注册使用）
    appcenterWebsite: 'https://test-appcenter-local.td365.com.cn/'
    // storeAdmin: 'http://teststoreadminv3.sissyun.com.cn/' // 微商城（微商店）
  },
  dev: {}
}

export function getApiUrl(hostType) {
  if (hostType) {
    return envInfos[env][hostType]
  } else {
    return envInfos[env].platformApi
  }
}

export function setHttpConfig(obj) {
  const hostType = obj && obj.hostType2 ? obj.hostType2 : HostType.platformApi
  const env2 = obj && obj.env2 ? obj.env2 : EnvType.prod
  const appVersion2 = obj && obj.appVersion2 ? obj.appVersion2 : appVersion

  httpHost = getApiUrl(hostType)
  env = env2
  appVersion = appVersion2
}

/** 请求类型 */
export const HttpMethod = {
  POST: 'POST',
  GET: 'GET'
}
